import "../fb";

import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
import "@/styles/modern.scss";
import store from "./store";
import router from "@/router";
import "vue-trix";

Vue.config.productionTip = false;
Vue.$router = router;

new Vue({
  vuetify,
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
